<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/suporte_anim.json'
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Material de Apoio",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vue3Lottie,
  },
  methods: {},
  data() {
    return {
      animationJson,
      updating: true,
      title: "Material de Apoio",
      items: [
        {
          text: "Suporte",
          href: "/",
        },
        {
          text: "Material de Apoio",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted suporte-pesquisa_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  }

};
</script>

<template>
  <Layout>


    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 30px; right: 10px;">
                    <Vue3Lottie :animationData="animationJson" :height="330" :width="220" />
    </span>

    <div class="row" v-if="!updating">
      <div class="col-xl-12 col-lg-12"> <br><br><br>
        <div class="card">
          <div> <br><br><br>
            <div class="row justify-content-center align-items-center">
              <div class="col-xl-10">
                <div>

                  <div class="row mt-5">

                    <div class="col-sm-3">
                      <div class="card p-2 border shadow-none">
                        <div class="p-2">
                          <a href="https://www.youtube.com/watch?v=MePzwJryl-o"
                             target="_blank"
                             class="text-dark">
                            <h5>
                              Tutorial Entrada de Mercadoria
                            </h5>
                          </a>
                          <p class="text-muted mb-0">31 Jan, 2024</p>
                        </div>
                        <div class="d-flex justify-content-center">
                          <iframe class="embed-responsive-item"
                              width="294" height="240"
                              src="https://www.youtube.com/embed/MePzwJryl-o"
                              allowfullscreen>
                          </iframe>
                        </div>
                        <div class="p-3">
                          <ul class="list-inline">
                            <li class="list-inline-item me-3">
                              <a href="javascript:void(0);" class="text-muted">
                                <i class="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                                Suporte / Capacitação
                              </a>
                            </li>
                          </ul>
                          <p>
                            Entenda como funciona o processo de entrada de mercadoria no estoque, o processo de importar nota fiscal, etc...
                          </p>
                          <div> <br>
                            <a href="https://www.youtube.com/watch?v=MePzwJryl-o"
                               target="_blank"
                               class="text-primary"
                            >Mais detalhes <i class="mdi mdi-arrow-right"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="card p-2 border shadow-none">
                        <div class="p-2">
                          <a href="https://www.youtube.com/watch?v=o534kK5x2P8"
                             target="_blank"
                             class="text-dark">
                            <h5>
                              Tutorial OS de Entrada
                            </h5>
                          </a>
                          <p class="text-muted mb-0">31 Jan, 2024</p>
                        </div>
                        <div class="d-flex justify-content-center">
                          <iframe class="embed-responsive-item"
                              width="294" height="240"
                              src="https://www.youtube.com/embed/o534kK5x2P8"
                              allowfullscreen>
                          </iframe>
                        </div>
                        <div class="p-3">
                          <ul class="list-inline">
                            <li class="list-inline-item me-3">
                              <a href="javascript:void(0);" class="text-muted">
                                <i class="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                                Suporte / Capacitação
                              </a>
                            </li>
                          </ul>
                          <p>
                            Entenda como funciona a tela de ordem de serviço da nota fiscal de entrada, o processo de conferência da nota, etc...
                          </p>
                          <div> <br>
                            <a href="https://www.youtube.com/watch?v=o534kK5x2P8"
                               target="_blank"
                               class="text-primary"
                            >Mais detalhes <i class="mdi mdi-arrow-right"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="card p-2 border shadow-none">
                        <div class="p-2">
                          <a href="https://www.youtube.com/watch?v=2Y5FXJoev44"
                             target="_blank"
                             class="text-dark">
                            <h5>
                              Tutorial Estoque do Produto
                            </h5>
                          </a>
                          <p class="text-muted mb-0">31 Jan, 2024</p>
                        </div>
                        <div class="d-flex justify-content-center">
                          <iframe class="embed-responsive-item"
                              width="294" height="240"
                              src="https://www.youtube.com/embed/2Y5FXJoev44"
                              allowfullscreen>
                          </iframe>
                        </div>
                        <div class="p-3">
                          <ul class="list-inline">
                            <li class="list-inline-item me-3">
                              <a href="javascript:void(0);" class="text-muted">
                                <i class="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                                Suporte / Capacitação
                              </a>
                            </li>
                          </ul>
                          <p>
                            Entenda como funciona a tela de visualização do estoque do produto, verificar o saldo atual do produto, as movimentações de entrada e saída deste produto, etc...
                          </p>
                          <div>
                            <a href="https://www.youtube.com/watch?v=2Y5FXJoev44"
                               target="_blank"
                               class="text-primary"
                            >Mais detalhes <i class="mdi mdi-arrow-right"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="card p-2 border shadow-none">
                        <div class="p-2">
                          <a href="https://www.youtube.com/watch?v=wOxQxgH9RKY"
                             target="_blank"
                             class="text-dark">
                            <h5>
                              Tutorial Inventário de Estoque
                            </h5>
                          </a>
                          <p class="text-muted mb-0">26 Jan, 2024</p>
                        </div>
                        <div class="d-flex justify-content-center">
                          <iframe class="embed-responsive-item"
                              width="294" height="240"
                              src="https://www.youtube.com/embed/wOxQxgH9RKY"
                              allowfullscreen>
                          </iframe>
                        </div>
                        <div class="p-3">
                          <ul class="list-inline">
                            <li class="list-inline-item me-3">
                              <a href="javascript:void(0);" class="text-muted">
                                <i class="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                                Suporte / Capacitação
                              </a>
                            </li>
                          </ul>
                          <p>
                            Entenda como funciona a tela de inventário de estoque, balanço de estoque, etc...
                          </p>
                          <div> <br> <br>
                            <a href="https://www.youtube.com/watch?v=wOxQxgH9RKY"
                               target="_blank"
                               class="text-primary"
                            >Mais detalhes <i class="mdi mdi-arrow-right"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr class="my-4" />

                  <div class="text-center">
                    <ul
                        class="pagination justify-content-center pagination-rounded"
                    >
                      <li class="page-item">
                        <router-link to="/suporte/material3" class="text-dark">
                        <a href="javascript:void(0);" class="page-link"
                        ><i class="mdi mdi-chevron-left"></i
                        ></a></router-link>
                      </li>
                      <li class="page-item">
                        <router-link to="/suporte/material" class="text-dark">
                        <a href="javascript:void(0);" class="page-link">1</a>
                        </router-link>
                      </li>
                      <li class="page-item">
                        <router-link to="/suporte/material2" class="text-dark">
                          <a href="javascript:void(0);" class="page-link">2</a>
                        </router-link>
                      </li>
                      <li class="page-item">
                        <router-link to="/suporte/material3" class="text-dark">
                        <a href="javascript:void(0);" class="page-link">3</a>
                        </router-link>
                      </li>
                      <li class="page-item active">
                        <router-link to="/suporte/material4" class="text-dark">
                          <a href="javascript:void(0);" class="page-link">4</a>
                        </router-link>
                      </li>
                      <li class="page-item disabled">
                        <a href="javascript:void(0);" class="page-link">5</a>
                      </li>
                      <li class="page-item disabled">
                        <a href="javascript:void(0);" class="page-link">...</a>
                      </li>
                      <li class="page-item disabled">
                        <a href="javascript:void(0);" class="page-link">10</a>
                      </li>
                      <li class="page-item disabled">
                        <a href="javascript:void(0);" class="page-link"
                        ><i class="mdi mdi-chevron-right"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>

  </Layout>
</template>


